import { useRef } from "react";
import { Input, Button, Tooltip } from "antd";
import { t } from "i18next";

/**
 * Message template editor: title + body textarea with one-click placeholder insertion (at the cursor) and a live
 * preview where each placeholder is replaced by its sample value.
 */
export default function NotificationTemplateEditor({ title, body, onTitleChange, onBodyChange, placeholders = [] }) {
    const bodyRef = useRef(null);

    const insertPlaceholder = (token) => {
        const el = bodyRef.current?.resizableTextArea?.textArea;
        const text = body || '';
        if (!el) {
            onBodyChange(text + token);
            return;
        }
        const start = el.selectionStart ?? text.length;
        const end = el.selectionEnd ?? text.length;
        const next = text.substring(0, start) + token + text.substring(end);
        onBodyChange(next);
        // restore caret just after the inserted token
        setTimeout(() => {
            el.focus();
            const pos = start + token.length;
            el.setSelectionRange(pos, pos);
        }, 0);
    };

    const preview = (() => {
        let out = body || '';
        placeholders.forEach(p => { out = out.split(p.token).join(p.sample); });
        return out;
    })();

    return (
        <div>
            <div style={{ marginBottom: 6 }}>
                <Input
                    size="small"
                    placeholder={t('Title (optional)')}
                    value={title || ''}
                    onChange={(e) => onTitleChange(e.target.value)}
                />
            </div>
            <Input.TextArea
                ref={bodyRef}
                rows={3}
                value={body || ''}
                onChange={(e) => onBodyChange(e.target.value)}
                placeholder={t('Message content')}
            />
            <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {placeholders.map(p => (
                    <Tooltip key={p.token} title={`${p.label} → ${p.sample}`}>
                        <Button size="small" onClick={() => insertPlaceholder(p.token)}>{p.token}</Button>
                    </Tooltip>
                ))}
            </div>
            {body ? (
                <div style={{ marginTop: 6, padding: 8, background: '#f5f5f5', borderRadius: 4, fontSize: 12, whiteSpace: 'pre-wrap' }}>
                    <span style={{ color: '#8c8c8c' }}>{t('Preview')}: </span>{preview}
                </div>
            ) : null}
        </div>
    );
}
